var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ul',{staticClass:"course_text"},_vm._l((_vm.info),function(item,index){return _c('li',{key:index},[_c('div',{staticClass:"label"},[_vm._v(_vm._s(item.label))]),_c('div',{staticClass:"text"},[_vm._v(_vm._s(item.text))])])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }